import { Component, Input } from '@angular/core';

@Component({
  selector: 'tangram-theme-extraction-card',
  templateUrl: './theme-extraction-card.component.html',
  styleUrls: ['./theme-extraction-card.component.scss']
})
export class ThemeExtractionCardComponent {
  @Input() themes: Array<{ name: string; evidence: number; description: string }> = [];
}
